import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CreateGates from '../createGates/createGates';
import ProductInventory from '../formSection/productInventory/productInventory';
import ProductInventoryEdit from 'components/sales/formSection/editPostSaleApt/materialHardwareSection/productInventoryEdit';
import ProductMasterInventory from '../formSection/editPostSaleApt/materialHardwareSection/productMasterInventory';
import ProductMasterInventoryEdit from '../formSection/editPostSaleApt/materialHardwareSection/productMaterInventoryEdit';

const Inventory = ({
  data,
  handleGatesData,
  handleProductData,
  getMateriaById,
  getBrandById,
  getMaterial,
  getBrand,
  postSalesData,
  editProduct=false,
  commData,
  inventoryMaster,
  prefilledDataForEdit=null
}) => { //console.log('sub_type ' + JSON.stringify(data));
  const [products, setProducts] = useState([]);
// console.log(postSalesData)
// console.log(data?.hardware_category?.product)
  // useEffect(() => {
  //   if (postSalesData!=null) {
  //     // setProducts(data?.hardware_category?.product);
  //   }
  // }, [data]);
  useEffect(() => {
    if (data?.hardware_category?.product) {
      setProducts(data?.hardware_category?.product);
    }
  }, [data]);

  const handleremoveValue = (info) => {
    if (info[0].category_id !== '' && data?.hardware_category) {
      const { hardware_category } = data;
      const removedData = hardware_category.product.filter(
        (item) => item.id === info[0].category_id
      );
      setProducts([...products, ...removedData]);
    }
  };

  const handleDataFilter = (id) => {
    if (data?.hardware_category) {
      for (const obj of id) {
        if (obj?.category_id !== '') {
          const filterData = products.filter((item) => {
            return item.id !== obj.category_id;
          });
          setProducts(filterData);
        }
      }
    }
  };

  return (
    <Fragment>
      {/* <CreateGates data={data} handleValue={handleGatesData} /> */}
      {(editProduct && editProduct === true) ? 
          <>
           {(parseInt(data?.commercialData?.commercial_type_id) === 5) ? (
            <ProductMasterInventoryEdit
              data={products}
              getMaterial={getMaterial}
              getMateriaById={getMateriaById}
              handleValue={handleProductData}
              handleremoveValue={handleremoveValue}
              // handleDataFilter={handleDataFilter}
              prefilledData={postSalesData}
              getBrand={getBrand}
              getBrandById={getBrandById}
              commData={commData}
              prefilledDataForEdit={inventoryMaster}
            />
          ) : (
            <ProductInventoryEdit
              data={products}
              getMaterial={getMaterial}
              getMateriaById={getMateriaById}
              handleValue={handleProductData}
              handleremoveValue={handleremoveValue}
              // handleDataFilter={handleDataFilter}
              prefilledData={postSalesData}
              getBrand={getBrand}
              getBrandById={getBrandById}
              commData={commData}
            />
          )}
          </>
          
      : 
      <>
      {(parseInt(data?.commercialData?.commercial_type_id) === 5) ? (
        <ProductMasterInventory
          data={products}
          getMaterial={getMaterial}
          getMateriaById={getMateriaById}
          handleValue={handleProductData}
          handleremoveValue={handleremoveValue}
          prefilledData={inventoryMaster}
          getBrand={getBrand}
          getBrandById={getBrandById}
          commData={commData}
        />
      ) : (
        <ProductInventory
          data={products}
          getMaterial={getMaterial}
          getMateriaById={getMateriaById}
          handleValue={handleProductData}
          handleremoveValue={handleremoveValue}
          postSalesData={postSalesData}
          getBrand={getBrand}
          getBrandById={getBrandById}
          commData={commData}
        />
      )}
      </>
      }
    </Fragment>
  );
};

Inventory.propTypes = {
  data: PropTypes.any,
  handleGatesData: PropTypes.func,
  handleProductData: PropTypes.func,
};

export default Inventory;
